import { Box } from '@televet/kibble-ui';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Task } from 'pages/Tasks/types';
import React from 'react';

type TaskDetailAutomationRunProps = {
  task: Task;
};

const TaskDetailAutomationRun = ({ task }: TaskDetailAutomationRunProps): JSX.Element => {
  return (
    <Box>
      <Text as="p" mb={1}>
        Task
      </Text>
      <Text fontWeight="bold">{task.name}</Text>
    </Box>
  );
};

export default TaskDetailAutomationRun;
